import {
  SuccessMessageContext,
  type SuccessMessageContextType,
} from '@/shared/contexts/successMessageContextValue';
import { useContext } from 'react';

export const useSuccessMessage = (): SuccessMessageContextType => {
  const context = useContext(SuccessMessageContext);
  if (!context) {
    throw new Error('useSuccessMessage must be used within a SuccessMessageProvider');
  }
  return context;
};
